module.exports = __webpack_public_path__ + "img/AC.fdcefad7.jpg";